export const getPercentageDifference = (
  rawValueA?: number,
  rawValueB?: number,
): number => {
  if (!rawValueA || !rawValueB) return 0;
  return ((rawValueA - rawValueB) / rawValueA) * 100;
};
